import { forwardRef, useState, useRef, useEffect } from 'react';
import { containerStyles } from './CroppableContentStyles.js';
import { useMergeRefs } from 'use-callback-ref';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { useHoverableTooltip } from '../Tooltip/useTooltip.js';
import { Tooltip } from '../Tooltip/Tooltip.js';

const CroppableContent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    placement,
    id: tooltipId,
    ...rest
  } = _ref;
  const [openTooltip, setOpenTooltip] = useState(false);
  const contentRef = useRef(null);
  const {
    opened
  } = useHoverableTooltip(contentRef);
  const newRef = useRef(null);
  const containerRef = useMergeRefs([newRef, ref]);
  useEffect(() => {
    var _containerRef$current, _contentRef$current;
    const containerWidth = ((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth) || 0;
    const contentWidth = ((_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.offsetWidth) || 0;
    setOpenTooltip(contentWidth > containerWidth && opened);
  }, [containerRef, contentRef, opened]);
  return jsxs("div", {
    ref: containerRef,
    css: containerStyles,
    ...rest,
    children: [jsx("span", {
      ref: contentRef,
      children: children
    }), jsx(Tooltip, {
      id: tooltipId,
      placement: placement,
      isOpen: openTooltip,
      reference: containerRef.current,
      children: children
    })]
  });
});
CroppableContent.displayName = 'CroppableContent';

export { CroppableContent };
//# sourceMappingURL=CroppableContent.js.map
